var MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
var THIS_MONTH = /*#__PURE__*/new Date().getMonth();
var getMonthName = function getMonthName() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  return MONTHS[month];
};
export default getMonthName;